import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";

function useDeleteContaRecorrente() {
  const queryClient = useQueryClient();
  return useMutation(
    `delete/v1/conta-recorrente`,
    (id: string) =>
      http.delete(`/v1/conta-recorrente/${id}`),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: ({ queryKey }) =>
            typeof queryKey === "string" && queryKey.startsWith("/v1/conta-recorrente"),
        });
      },
    }
  );
}

export default useDeleteContaRecorrente;
